(() => {
  'use strict';
  if (window.joffzWidgetControlsReady) return;
  window.joffzWidgetControlsReady = true;
  const words = {
    en:['Play music','Pause music'], de:['Musik abspielen','Musik pausieren'],
    fr:['Écouter la musique','Mettre la musique en pause'], es:['Reproducir música','Pausar música'],
    it:['Riproduci musica','Metti in pausa la musica'], tr:['Müziği çal','Müziği duraklat'],
    nl:['Muziek afspelen','Muziek pauzeren']
  };
  const labels = words[document.documentElement.lang.split('-')[0]] || words.en;
  let musicButton;
  let googleBadge;
  let positionFrame;
  function align() {
    cancelAnimationFrame(positionFrame);
    positionFrame = requestAnimationFrame(() => {
      const widget = document.getElementById('rams-widget');
      const badge = document.getElementById('google-merchantwidget-iframe-wrapper');
      if (!widget || !badge) return;
      const rect = badge.getBoundingClientRect();
      if (rect.width <= 0 || rect.width > 110 || rect.height <= 0 || rect.height > 120 || rect.top < window.innerHeight / 2) return;
      widget.style.setProperty('--joffz-music-left', `${Math.max(12, rect.left + (rect.width - 44) / 2)}px`);
      widget.style.setProperty('--joffz-music-bottom', `${Math.max(76, window.innerHeight - rect.top + 10)}px`);
    });
  }
  function mount() {
    const widget = document.getElementById('rams-widget');
    const button = document.getElementById('rams-button');
    if (widget && button && !button.dataset.joffzMusic) {
      button.dataset.joffzMusic = 'true';
      button.setAttribute('role', 'button');
      button.tabIndex = 0;
      const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      icon.setAttribute('viewBox', '0 0 24 24');
      icon.setAttribute('aria-hidden', 'true');
      icon.setAttribute('focusable', 'false');
      icon.classList.add('joffz-music-icon');
      icon.innerHTML = '<path class="joffz-music-icon__play" d="M8 5.5a.75.75 0 0 1 1.13-.65l10 6.5a.75.75 0 0 1 0 1.3l-10 6.5A.75.75 0 0 1 8 18.5z"/><path class="joffz-music-icon__pause" d="M6.5 5h4v14h-4zm7 0h4v14h-4z"/>';
      button.append(icon);
      const sync = () => {
        const playing = widget.classList.contains('rams--playing');
        const label = labels[playing ? 1 : 0];
        button.setAttribute('aria-pressed', String(playing));
        button.setAttribute('aria-label', label);
        button.title = label;
      };
      let spaceArmed = false;
      button.addEventListener('keydown', event => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        if (event.repeat) return;
        if (event.key === 'Enter') button.click();
        else spaceArmed = true;
      });
      button.addEventListener('keyup', event => {
        if (event.key !== ' ') return;
        event.preventDefault();
        if (spaceArmed) button.click();
        spaceArmed = false;
      });
      button.addEventListener('blur', () => {spaceArmed = false;});
      new MutationObserver(sync).observe(widget, {attributes:true, attributeFilter:['class']});
      sync();
      musicButton = button;
    }
    const badge = document.getElementById('google-merchantwidget-iframe-wrapper');
    if (badge && badge !== googleBadge) {
      googleBadge = badge;
      if (typeof ResizeObserver !== 'undefined') new ResizeObserver(align).observe(badge);
    }
    align();
    return Boolean(musicButton && googleBadge);
  }
  function start() {
    if (!mount()) {
      const discovery = new MutationObserver(() => {if (mount()) discovery.disconnect();});
      discovery.observe(document.body, {childList:true, subtree:true});
      setTimeout(() => discovery.disconnect(), 20000);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
  window.addEventListener('resize', align, {passive:true});
  document.addEventListener('shopify:section:load', mount);
})();
